var React = require('react');

function CloseIcon (props) {
    return React.createElement("svg",props,[React.createElement("line",{"y1":"-0.5","x2":"25.6125","y2":"-0.5","transform":"matrix(0.780869 0.624695 -0.298275 0.95448 1 1)","stroke":"black","key":0}),React.createElement("line",{"y1":"-0.5","x2":"25.6125","y2":"-0.5","transform":"matrix(0.780869 -0.624695 0.298275 0.95448 1 17)","stroke":"black","key":1})]);
}

CloseIcon.defaultProps = {"width":"22","height":"17","viewBox":"0 0 22 17","fill":"none"};

module.exports = CloseIcon;

CloseIcon.default = CloseIcon;
